// extracted by mini-css-extract-plugin
export default {"list":"ScrollCarousel-module__list-DMTz","item":"ScrollCarousel-module__item-ag3L"};